<script>
import { mapState } from 'vuex';
import CityMap from '../../components/cityMap.vue';

export default {
    name: "groggery",
    data() {
        return {};
    },
    computed: {
        ...mapState(['employeeData'])
    },
    components: {
        CityMap,
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="groggery">
        <CityMap :map="employeeData.hotel_image" :data="employeeData.hotel_map"/>
    </div>
</template>

<style scoped lang="scss">

</style>